import Builder from '../Builder.js';

export class After extends Builder {
  static buildMethod = 'after'
  static buildOrder  = 100
  // TODO
}

export default After